import { Analytics } from '../../protocols/analytics';
import { EnvironmentHelper } from '../../../enviromentHelper';
import { AnalyticsUserProperties } from '~/composables/analytics/constants';

export class PostHogAnalyticsProviderAdapter extends Analytics {
  constructor(posthogInstance) {
    super();
    this.posthog = posthogInstance;
  }

  capture(eventName, properties = {}) {
    if (!this.posthog || typeof window === 'undefined') {
      if (!EnvironmentHelper.isProduction()) {
        // eslint-disable-next-line no-console
        console.log('PostHog is not available. Skipping event capture...');
      }
      return;
    }

    try {
      const userProperties = {};
      const eventProperties = { ...properties };

      Object.keys(properties).forEach((key) => {
        if (properties[key] !== null && AnalyticsUserProperties.includes(key)) {
          if (Array.isArray(properties[key])) {
            userProperties[key] = properties[key].join(',');
          } else if (typeof properties[key] === 'object') {
            userProperties[key] = JSON.stringify(properties[key]);
          } else {
            userProperties[key] = properties[key];
          }
        }
      });

      if (Object.keys(userProperties).length > 0) {
        eventProperties.$set = userProperties;
      }

      this.posthog.capture(eventName, eventProperties);
    } catch (error) {
      if (!EnvironmentHelper.isProduction()) {
        // eslint-disable-next-line no-console
        console.error('[PostHog Tracker Error]:', error);
      }
    }
  }
}
